import { capitalizeName } from '@eika-infrastruktur/format';
import type {
    AccountForChildEligibilityDetails,
    CreateShareSavingsAccountForChildProcess,
    PersonInfo,
} from '@generated-types';

const getPrettyPersonName = ({ name }: PersonInfo) => capitalizeName(name);

export const formatEligibilityPersonNames = (eligibility: AccountForChildEligibilityDetails) => ({
    ...eligibility,
    child: {
        ...eligibility.child,
        name: getPrettyPersonName(eligibility.child),
    },
    currentBankCreateShareSavingsAccountEligibility: {
        ...eligibility.currentBankCreateShareSavingsAccountEligibility,
        applicantParent: {
            ...eligibility.currentBankCreateShareSavingsAccountEligibility.applicantParent,
            name: getPrettyPersonName(eligibility.currentBankCreateShareSavingsAccountEligibility.applicantParent),
        },
        approverParent: {
            ...eligibility.currentBankCreateShareSavingsAccountEligibility.approverParent,
            name: getPrettyPersonName(eligibility.currentBankCreateShareSavingsAccountEligibility.approverParent),
        },
    },
});

export const formatProcessPersonNames = (process: CreateShareSavingsAccountForChildProcess) => ({
    ...process,
    child: {
        ...process.child,
        name: getPrettyPersonName(process.child),
    },
    applicantParent: {
        ...process.applicantParent,
        name: getPrettyPersonName(process.applicantParent),
    },
    approverParent: {
        ...process.approverParent,
        name: getPrettyPersonName(process.approverParent),
    },
});
